// extracted by mini-css-extract-plugin
export default {"footer_copyright_onestream":"footer_footer_copyright_onestream__Yw4ZN","footer_ul":"footer_footer_ul__OwJBF","footer_li":"footer_footer_li__r7Ld8"};